export default {
  screeningsAvailable: [],
  screeningsFilter: [],
  isscreeningsFilter: false,
  screeningsSort: [],
  holdSort: [],
};
